import { connect } from 'react-redux';
import ProviderIncentiveCost from './provider-incentive-cost';
import {
  removeProviderFromIncentive,
  addProviderToIncentive,
  applySearchFilter,
  pickIncentiveCost,
  clearIncentiveCost,
  addManyIncentives,
  startAddManyIncentives,
  finishAddManyIncentives,
  flashMessage,
  deleteIncentive
} from './actions';

const mapStateToProps = state => {
  const { providerIncentiveCost } =  state;
  return providerIncentiveCost;
};

const mapDispatchToProps = dispatch => ({
  applySearchFilter: filters => {
    dispatch(applySearchFilter(filters));
  },
  pickIncentiveCost: cost => {
    dispatch(pickIncentiveCost(cost));
  },
  addProviderToIncentive: (incentiveCostId, providerId) => {
    dispatch(addProviderToIncentive(incentiveCostId, providerId));
  },
  removeProviderFromIncentive: (incentiveCostId, providerId, deletionReason) => {
    dispatch(removeProviderFromIncentive(incentiveCostId, providerId, deletionReason));
  },
  clearIncentiveCost: () => {
    dispatch(clearIncentiveCost());
  },
  addManyIncentives: incentives => {
    dispatch(addManyIncentives(incentives));
  },
  startAddManyIncentives: () => {
    dispatch(startAddManyIncentives());
  },
  finishAddManyIncentives: () => {
    dispatch(finishAddManyIncentives());
  },
  flashMessage: message => {
    dispatch(flashMessage(message));
  },
  deleteIncentive: incentiveCostId => {
    dispatch(deleteIncentive(incentiveCostId));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProviderIncentiveCost);
